import withErrorHandler from '../../../modules/error/ErrorHandlerWrapper';
import CheckoutPriceBlock, { CheckoutPriceBlockProps } from './CheckoutPriceBlock';
import withInteractor from './CheckoutPriceBlock.interactor';
import withPresenter from './CheckoutPriceBlock.presenter';

export type { CheckoutPriceBlockProps };
export default withInteractor(withPresenter(withErrorHandler(CheckoutPriceBlock)));
